import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function TagTypeChip({ label }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 24,
        px: "10px",
        borderRadius: "100px",
        border: "1px solid #D5DCE1",
        background: "#FFF",
        color: "#405261",
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </Box>
  );
}
